export enum LoginMethod {
  WA = 'WA',
  MN = 'MN'
}
